/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useDispatch } from 'react-redux'

import { Alert, IconButton, Snackbar } from '@mui/material'
import { SnackbarProvider, useSnackbar } from 'notistack'

import { setAlertMessages } from 'redux/ui/common/alertUI'

import { AlertData, AlertVariant, IAlert } from 'types'
import { PURE_BLACK, PURE_WHITE } from 'utils/customizedTheme'
import { Close, Report } from '@mui/icons-material'

interface IAlertProps {
  message: AlertData
  type: AlertVariant
  time: number
}

const Alerts: FC<IAlertProps> = ({ message, type, time }) => {
  const { enqueueSnackbar } = useSnackbar()

  enqueueSnackbar( `${message?.field && message?.field !== 'non_field_errors' ? message.field + ': ' : ''}${message?.message}` || 'error', {
    variant: type,
    autoHideDuration: time,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  })

  return null
}

const AlertMessage: FC<IAlert> = ({ messages, type = 'warning', time = 6000 }) => {
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(setAlertMessages([]))
  }


  return (
    <section className='alerts-wrapper'>
      {type === 'success' || type === 'warning' ? (
        <Snackbar
          open={true}
          autoHideDuration={time}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Alert variant='filled' severity={type}>
            <>
              {messages?.data}
              <IconButton aria-label='close' size='small' onClick={handleClose} color='default' sx={{position: 'absolute', top: '50%', right: '0', translate: '-30% -50%'}}>
                <Close fontSize='small' sx={{ color: PURE_BLACK, opacity: '0.5', '&:hover': {opacity: '1'}}}/>
              </IconButton>
            </>
          </Alert>
        </Snackbar>
      ) : (
        <SnackbarProvider maxSnack={100} onClose={handleClose}  iconVariant={{ error: <Report sx={{marginRight: '0.5rem'}}/> }}
        action={[
          <IconButton aria-label='close' size='small' onClick={handleClose} color='default'>
            <Close fontSize='small' sx={{ color: PURE_WHITE, opacity: '0.5', '&:hover': {opacity: '1'}}}/>
          </IconButton>,
        ]}>
          {messages?.data &&
            messages?.data?.length > 0 && Array.isArray(messages?.data) &&
            messages?.data?.map((message, i) => <Alerts key={`alert_${i}`} message={message} type={type} time={time} />)}
        </SnackbarProvider>
      )}
    </section>
  )
}

export default AlertMessage